import { useState, useEffect } from "react";
import axios from "axios";

const useMarketGroupings = (eventId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMarketGroupings = async () => {
      setLoading(true);
      try {
        const url =
          window.location.hostname === "localhost"
            ? `https://tool.bonusbank.com.au/api/v3/event/${eventId}/?market_groupings`
            : `${window.location.origin}/wp-json/bonusbank/v1/event/${eventId}/marketgroupings`;
        const response = await axios.get(url, {
          headers: {
            "content-type": "application/json",
            "X-WP-Nonce": window.nonce,
          },
        });
        setData(response.data);
        setError(null);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchMarketGroupings();
  }, [eventId]);

  return { data, loading, error };
};

export default useMarketGroupings;
